import React, { useEffect, useState } from 'react';

import { useAuth } from '../../../hooks/useAuth';
import { useNavigate } from '../../../hooks/useNavigate';
import { AsyncStorageKey, useStorage } from '../../../hooks/useStorage';
import { Card } from '../../common/Card';
import { View } from '../../common/View';

import { RemoteSignupForm } from './RemoteSignupForm';

type RemoteSignupProps = {};

export function RemoteSignup({}: RemoteSignupProps) {
  const { isAuthenticated, hasRemoteAccount } = useAuth();
  const { getItem: getUserLocalData } = useStorage(AsyncStorageKey.USER_DATA);
  const navigate = useNavigate();

  const [isExistingLocalUser, setIsExistingLocalUser] = useState(false);

  useEffect(() => {
    // @TODO: also check if has account/email exists?
    if (isAuthenticated) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    (async () => {
      const userData = await getUserLocalData();
      setIsExistingLocalUser(!!userData && !hasRemoteAccount);
    })();
  }, []);

  return (
    <View
      style={{
        margin: '0 auto',
        justifyContent: 'center',
        width: '100%',
        maxWidth: 400,
      }}
    >
      <Card style={{ padding: 24 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '0.83em 0',
            gap: 8,
          }}
        >
          <h2 style={{ margin: 0 }}>Sign up</h2>
          {isExistingLocalUser && (
            <span style={{ color: '#e68900' }}>
              To keep your privacy and security at the highest level, we now ask
              you to set up a password protected account. Don’t worry — your
              budget files stay completely local and private on your device.
              Once you sign into your account, you'll be right back to managing
              your budget.
            </span>
          )}
        </div>
        <RemoteSignupForm />
      </Card>
    </View>
  );
}
